import React, { useMemo } from "react";
import PowerBiReports from "../common/components/PowerBiReports";
import { useSelector } from "react-redux";
import config from "../config";
import { enums } from "../common/lib";

/**
 * PowerBI Reports Component
 */
export default () => {
    const { userOrganisations } = useSelector((state) => state);

    const res = useMemo(() => {
        // If stellantis org show everything

        if (
            userOrganisations?.item?.id ===
            enums.organisationIds.stellantisFinanceFrance
        ) {
            return config.powerBI.operations;
        }

        /** Remove this for other orgs  */
        return config.powerBI.operations.filter(
            (item) => item.label !== "Invoice"
        );
    }, [userOrganisations, config.powerBI.reports]);
    return (
        <PowerBiReports
            page="operations"
            reportTabs={[...res]}
            reportList={res}
        />
    );
};
